import api from "./api";
import { PaymentModeType } from "../components/References/PaymentMode/paymentType";
export type DeletpaymentModesDto = {
  id: number | string;
};

/*Search & filter */

export const getpaymentModesApi = async (body: {
  limit: number;
  q: string;
  isActive?: boolean;
}) => {
  let url = `/paymentModes?limit=${body.limit}&q=${body.q.toString()}`;

  if (body.isActive !== undefined) {
    url += `&isActive=${body.isActive}`;
  }

  return await api.get(url);
};


/*delete payment */

// export const getpaymentModes = async () => {
//   return await api.get("/paymentModes");
// };
export const getPaymentModesDropdown = async () => {
  return await api.get("/paymentModes/dropdown");
};


export const deletePaymentModes = async (dto: DeletpaymentModesDto) => {
  return await api.delete(`/paymentModes/${dto.id}`);
};

/*payment By id*/

export const getpaymentModesById = async (
  paymentModesId: string | undefined
) => {
  return await api.get(`/paymentModes/${paymentModesId}`);
};

/*create payment */

export const createpaymentModes = async (
  paymentModesDetails: PaymentModeType
) => {
  return await api.post("/paymentModes", paymentModesDetails);
};

/*edit payment */

export const editpaymentModes = async (
  paymentModesId: any,
  body: PaymentModeType
) => {
  return await api.put(`/paymentModes/${paymentModesId}`, body);
};

export const getpaymentModes = async () => {
  return await api.get("/paymentModes");
};